import { createReducer } from "deox";

import {
  paymentMethodError,
  paymentMethodLoading,
  PaymentMethodSaveErrorPayload,
  paymentMethodSaved,
  paymentMethodSaveError,
  paymentMethodSaveInit,
  paymentMethodSaving,
  paymentMethodSuccess,
} from "./paymentMethodStateActions";
import { ICreatePaymentMethodHttpResponse, IPaymentMethodHttpResponse } from "../../../types/types";
import { purge } from "../purge/purgeStateActions";

export interface PaymentMethodState {
  payload: IPaymentMethodHttpResponse | null;
  savePayload: ICreatePaymentMethodHttpResponse | null;
  isError: boolean;
  isSavingError: boolean;
  saveError: PaymentMethodSaveErrorPayload | null;
  isLoading: boolean;
  isSaving: boolean;
  isSaved: boolean;
  isLoaded: boolean;
}

export const initialState: PaymentMethodState = {
  payload: null,
  savePayload: null,
  isError: false,
  isLoading: false,
  isSaved: false,
  isSaving: false,
  isSavingError: false,
  saveError: null,
  isLoaded: false,
};

const paymentMethodReducer = createReducer(initialState, (handleAction) => [
  handleAction(
    paymentMethodSuccess,
    (state, action): PaymentMethodState => ({
      ...state,
      isLoading: false,
      isError: false,
      payload: action.payload,
      isLoaded: true,
    })
  ),
  handleAction(
    paymentMethodLoading,
    (state): PaymentMethodState => ({
      ...state,
      isLoading: true,
      isLoaded: false,
      isError: false,
    })
  ),
  handleAction(
    paymentMethodSaving,
    (state): PaymentMethodState => ({
      ...state,
      isSaving: true,
      isError: false,
      isSavingError: false,
      saveError: null,
      isSaved: false,
    })
  ),
  handleAction(
    paymentMethodSaved,
    (state, action): PaymentMethodState => ({
      ...state,
      isSaving: false,
      savePayload: action.payload,

      isSavingError: false,
      saveError: null,
      isSaved: true,
    })
  ),
  handleAction(
    paymentMethodError,
    (state): PaymentMethodState => ({
      ...state,
      isError: true,
      isLoading: false,
      isLoaded: false,
      isSaving: false,
      isSaved: false,
      payload: null,
      isSavingError: false,
    })
  ),
  handleAction(
    paymentMethodSaveError,
    (state, action): PaymentMethodState => ({
      ...state,
      isSaving: false,
      isSaved: false,
      savePayload: null,
      isSavingError: true,
      saveError: action.payload,
    })
  ),
  handleAction(paymentMethodSaveInit, (state) => ({
    ...state,
    isSaved: false,
    isSavingError: false,
    saveError: null,
    savePayload: null,
    isSaving: false,
  })),
  handleAction(purge, () => initialState),
]);

export default paymentMethodReducer;
